import CONSTANTES from "../constantes";


let initialState = {
  clientes: [],
}
export const reducerClientes = (state=initialState, action) => {
    switch (action.type) {
      case CONSTANTES.PUT_CLIENTES:
              return { ...state, clientes: action.clientes}
      case CONSTANTES.PUT_DETAIL_CLIENTE:
            return { ...state, detailCliente: action.cliente}
      case CONSTANTES.ADD_CLIENTE:
        state.clientes.unshift(action.cliente)
        return { ...state, clientes: [...state.clientes] }
      case CONSTANTES.PUT_CLIENTE:
        let id = action.cliente.CODIGO
        let datosCliente = action.cliente
        var indexDatosClienteEdit = state.clientes.findIndex(item => item.CODIGO === id)
        state.clientes.splice(indexDatosClienteEdit, 1, datosCliente)
        return { ...state, clientes: [...state.clientes] }
        
      default:   
        return state
    }
  }
